<!-- tienda-cajas-activador.php -->
<div class="home-metallic-area bg_color--15 pt--100 pt-lg--100 pt-md--80 pt-sm--80">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6 col-md-6 col-12">
                <div class="metarial-inner">
                    <div class="content">
                      
                        <h3 class="heading heading-h3 wow move-up">Escuela Akashica<sup>®</sup></h3>
                        <div class="desc mt--20 mb--65">
                            <p>
                            <li class="bk_pra font-18 line-height-1-87 wow move-up">Cajita de Serie Activador Akashico® Luz Ilimitada®</li>
                            <li class="bk_pra font-18 line-height-1-87 wow move-up">Cajita de Serie Activador Akashico® Luz Ilimitada® Niños</li>
                            <li class="bk_pra font-18 line-height-1-87 wow move-up">Cajita de Serie Activador Akashico® II</li>
                            <li class="bk_pra font-18 line-height-1-87 wow move-up">Cajita de Serie Conexión Akashico® </li>
                            
                            </p>
                              <div class="icon mb--30 mt--20 wow move-up">
                                <img src="assets/img/about/landing-icon.png" alt="Multipurpose">
                        </div>
                        </div>
                    </div>

                   

                </div>
            </div>
            <div class="col-lg-6 col-md-6 col-12 mt_sm--0">
                <div class="thumbnail text-center text-md-right wow move-up">
                    <img src="assets/img/about/home-product-landing-image-05.jpg" alt="Multipurpose">
                </div>
                
            </div>
        </div>
    </div>
</div>

 <!-- tienda-playera-institucional.php -->
 <div class="bk-cube-lanter-area  bg_color--1">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6 col-md-6 col-12">
                <div class="thumbnail wow move-up">
                    <img src="assets/img/about/home-product-landing-image-03.jpg" alt="Multipurpose">
                </div>
            </div>
            <div class="col-lg-6 col-md-6 col-12">
                <div class="cube-lanterinner">
                    <div class="content wow move-up">
                        <h3 class="heading heading-h3">Playera Institucional</h3>
                        <div class="desc mt--20">
                            <p class="bk_pra font-18 line-height-1-87">Se parte de la imagen de nuestra escuela. Pregunta por tallas disponibles. Costo por playera: $444 MXN + gastos de envio.  </p>
                            <form action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_top">
<input type="hidden" name="cmd" value="_s-xclick">
<input type="hidden" name="hosted_button_id" value="PBVXTPXTCUVQW">
<table>
<tr><td><input type="hidden" name="on0" value="Introduce la Talla">Introduce la Talla</td></tr><tr><td><input type="text" name="os0" maxlength="200"></td></tr>
</table>
<input type="image" src="https://www.paypalobjects.com/es_XC/MX/i/btn/btn_buynowCC_LG.gif" border="0" name="submit" alt="PayPal, la forma más segura y rápida de pagar en línea.">
<img alt="" border="0" src="https://www.paypalobjects.com/es_XC/i/scr/pixel.gif" width="1" height="1">
</form>

                        </div>
                    </div>
                    <div class="cube-feature mt--90 mt_md--40 mt_sm--40">
                        
                      
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


